import Tippy from '@tippyjs/react';
import { FC } from 'react';
import styled from 'styled-components';

import Typography from 'app/components/Typography';

import { usePolicyInUser } from 'app/hooks/policy';

import { ReactComponent as IconSetting } from 'app/assets/icons/icon-setting.svg';

import { useAuth } from '../../../../app/modules/auth';
import { toAbsoluteUrl } from '../../../helpers';
import { HeaderUserMenu } from '../../../partials';

const ShowAvatar = styled.div`
  width: 36px;
  height: 36px;
  margin-right: 10px;
`;

const Information = styled.div`
  .btn.btn-active-light:hover:not(.btn-active) {
    background-color: var(--primary-2) !important;
    p {
      color: var(--primary) !important;
    }
  }
  .btn.btn-active-light:active:not(.btn-active) {
    background-color: var(--primary-2) !important;
    p {
      color: var(--primary) !important;
    }
  }
  .btn.btn-active-light.show {
    background-color: var(--primary-2) !important;
    p {
      color: var(--primary) !important;
    }
  }
`;

const StyledTippy = styled(Tippy)`
  &.tippy-box {
    background-color: transparent;
    border-radius: 0;
    padding: 0;
    margin: 0;
    max-height: 430px;
  }

  .tippy-content {
    padding: 0;
    background-color: transparent;
  }
`;

const Topbar: FC<{
  isOpenUserMenu?: boolean;
  setIsOpenUserMenu?: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({ isOpenUserMenu, setIsOpenUserMenu }) => {
  const { currentUser } = useAuth();
  const permission = usePolicyInUser(currentUser?.policy ?? []);

  const handleToggleMenu = () => setIsOpenUserMenu?.(!isOpenUserMenu);

  return (
    <div
      className="d-flex align-items-stretch flex-shrink-0"
      style={{
        borderTop: `1px solid var(--neutral-3)`,
        padding: '12px 0',
        marginRight: 28,
      }}
    >
      <div className="topbar d-flex align-items-stretch flex-shrink-0">
        {/* begin::User */}
        <Information>
          <div className="d-flex align-items-center" id="kt_header_user_menu_toggle">
            <StyledTippy
              content={<HeaderUserMenu setVisible={setIsOpenUserMenu} />}
              interactive={true}
              arrow={false}
              placement="right-end"
              theme="light"
              animation="shift-away"
              appendTo={document.body}
              visible={isOpenUserMenu}
              onClickOutside={handleToggleMenu}
              maxWidth="none"
              className="user-menu-tippy"
              popperOptions={{
                strategy: 'fixed',
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      padding: 8,
                    },
                  },
                ],
              }}
            >
              <div
                className="btn btn-active-light d-flex align-items-center bg-hover-light"
                data-kt-menu-trigger="click"
                data-kt-menu-attach="parent"
                data-kt-menu-placement="right-end"
                style={{ padding: '10px 12px', width: 188 }}
                onClick={handleToggleMenu}
              >
                <ShowAvatar>
                  <img src={toAbsoluteUrl('/media/avatars/icon-avatar-default.svg')} alt="avatar" />
                </ShowAvatar>
                <div className="d-flex flex-column align-items-start justify-content-center">
                  <Typography variant="title-4" color="neutral-10">
                    {`${currentUser?.firstName} ${currentUser?.lastName}`}
                  </Typography>
                  <Typography fontSize={12} fontWeight={500} lineHeight={20} color="neutral-6">
                    {currentUser?.role.name}
                  </Typography>
                </div>

                {permission.systemAdmin ? (
                  <div style={{ display: 'flex', flex: 1, justifyContent: 'flex-end' }}>
                    <IconSetting />
                  </div>
                ) : null}
              </div>
            </StyledTippy>
          </div>
        </Information>
        {/* end::User */}
      </div>
    </div>
  );
};

export { Topbar };
